var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-time-here-wrapper"},[_c('div',{staticClass:"text-header-1 mb-8px"},[_vm._v(_vm._s(_vm.$t('customerInfoStep.firstTimeHere.text')))]),_c('div',{staticClass:"text-body-4"},[_vm._v(" "+_vm._s(_vm.$t('customerInfoStep.firstTimeHere.subtext'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }